import React, {useState} from 'react';
import './App.css';
import WizardSteps from "./wizard/WizardSteps";
import {Popover, Modal} from "antd-mobile";
import Icon from "@iconify/react";
import menuOutlined from '@iconify/icons-ant-design/menu-outlined';
import questionCircleOutlined from '@iconify/icons-ant-design/question-circle-outlined';
import desktopOutlined from '@iconify/icons-ant-design/desktop-outlined';
import leftCircleOutlined from '@iconify/icons-ant-design/left-circle-outlined';
import homeOutlined from '@iconify/icons-ant-design/home-outlined';
import Help from "./wizard/Help";
import {useLogin} from "./lib/bridgeHooks";
import {includes} from "lodash";

const Item = Popover.Item;
const modalAlert = Modal.alert;

// path to static files in apps public directory
const PublicRoot = React.createContext('');

const App = ({mccNav,publicRoot='', ...props}) => {

    const {profile} = useLogin();

    // todo Is this needed?
    /*
    const onWrapTouchStart = (e) => {
        // fix touch to scroll background page on iOS
        if (!/iPhone|iPod|iPad/i.test(navigator.userAgent)) {
            return;
        }
        const pNode = closest(e.target, '.am-modal-content');
        if (!pNode) {
            e.preventDefault();
        }
    }
    */

    return (
        <PublicRoot.Provider value={publicRoot}>
            <WizardSteps
                title={'MiAD Wizard'}
                menu={<PopMenu
                        mccNav={mccNav}
                        isAdSeller={includes(profile.TAG,'Ad Seller')}
                />}
                mccNav={mccNav}
            />
        </PublicRoot.Provider>
    );
};

const PopMenu = ({mccNav={}, isAdSeller=false, ...props})=>{

    const [visible, setVisible] = useState(false);
    const onSelect = (opt) => {
        const choice = opt.props.value;
        setVisible(false);

        if (choice in mccNav) {
            mccNav[choice]();
        } else if (choice==='help') {
            modalAlert('Wizard Help', <Help/>, [
                { text: 'OK', onPress: () => console.log('ok') },
            ]);
        }
    };

    //Todo data driven lib/PopMenu

  return <Popover
      mask
      visible={visible}
      overlay={[
          (<Item key="1" value="home" icon={<Icon icon={homeOutlined} />} style={{ whiteSpace: 'nowrap' }}
            >MCC Home</Item>),
          (isAdSeller && <Item key="2" value="adseller" icon={<Icon icon={leftCircleOutlined} />} style={{ whiteSpace: 'nowrap' }}
            >Return to Ad Seller</Item>),
          (<Item key="3" value="desktop" icon={<Icon icon={desktopOutlined} />} style={{ whiteSpace: 'nowrap' }}
            >Desktop Wizard</Item>),
          (<Item key="4" value="help" icon={<Icon icon={questionCircleOutlined} />}>
              <span style={{ marginRight: 5 }}>Help</span>
          </Item>),
      ]}
      onVisibleChange={(v)=>setVisible(v)}
      onSelect={onSelect}
  >
          <Icon icon={menuOutlined}  style={{ fontSize: '32px'}}/>
  </Popover>
};

export default App;
export {PublicRoot};